// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--1e6f4";
export var searchContainer = "styles-module--searchContainer--c73ab";
export var searchOverlay = "styles-module--searchOverlay--9a8b7";